"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _class, _descriptor, _temp;

var PhoneNumber = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(PhoneNumber, _Component);

  function PhoneNumber() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, PhoneNumber);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(PhoneNumber)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "profile", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      phoneNumber: _this.profile.phoneNumber
    };
    return _this;
  }

  babelHelpers.createClass(PhoneNumber, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.profile != this.props.profile) {
        this.setState({
          phoneNumber: this.props.profile.phoneNumber
        });
      }
    }
  }, {
    key: "setPhoneNumber",
    value: function setPhoneNumber(event) {
      this.setState({
        phoneNumber: event.target.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        "data-field": "phoneNumber",
        className: "form-group"
      }, _react.default.createElement("label", {
        htmlFor: "phoneNumber"
      }, "Phone number"), _react.default.createElement("input", {
        className: "form-control",
        name: "phoneNumber",
        id: "phoneNumber",
        value: this.state.phoneNumber,
        onChange: this.setPhoneNumber
      }));
    }
  }]);
  return PhoneNumber;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "profile", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setPhoneNumber", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setPhoneNumber"), _class.prototype)), _class);
exports.default = PhoneNumber;